import { useContext, useCallback } from 'react';

import { SelectContext } from './SelectContext';

export const useSelect = () => {
  const ctx = useContext(SelectContext);
  if (!ctx) {
    throw new Error('useSelect deve ser usado dentro de um SelectProvider');
  }

  const getSelectDominioPai = useCallback(
    (dominioPaiId: number) => {
      if (!dominioPaiId) {
        return [{ value: 0, label: 'Não informado' }];
      }

      const lista = ctx.dominiosSelect
        .filter((item) => Number(item.dominioPai) === Number(dominioPaiId))
        .sort((a, b) => (a.ordem ?? 0) - (b.ordem ?? 0))
        .map((item) => ({
          value: item.id,
          label: item.nome,
        }));

      // Adiciona opção padrão "Não informado" no topo
      return [{ value: 0, label: 'Não informado' }, ...lista];
    },
    [ctx.dominiosSelect],
  );

  const getSelectDominioPaiPuro = useCallback(
    (dominioPaiId: number) => {
      if (!dominioPaiId) {
        return [{ value: 0, label: 'Não informado' }];
      }

      const lista = ctx.dominiosSelect
        .filter((item) => Number(item.dominioPai) === Number(dominioPaiId))
        .sort((a, b) => (a.ordem ?? 0) - (b.ordem ?? 0))
        .map((item) => ({
          value: item.id,
          label: item.nome,
        }));

      // Retornando apenas as opções associadas ao registro pai
      return lista;
    },
    [ctx.dominiosSelect],
  );

  const getSelectDominiosRaiz = useCallback(() => {
    const lista = ctx.dominiosSelect
      .filter(
        (item) => item.dominioPai === null || item.dominioPai === undefined,
      )
      // Ordena pela propriedade 'ordem' em ordem crescente
      .sort((a, b) => (a.ordem ?? 0) - (b.ordem ?? 0))
      .map((item) => ({
        value: item.id,
        label: item.nome,
      }));

    return [{ value: 0, label: 'Não informado' }, ...lista];
  }, [ctx.dominiosSelect]);

  return {
    ...ctx,
    getSelectDominioPai,
    getSelectDominioPaiPuro,
    getSelectDominiosRaiz,
  };
};
